type ErrorExtraType = Partial<{
    url: string;
    method: string;
    request: {
        headers: any;
        body?: any;
    };
    response: any;
    traceId: string;
    status: number;
    statusText: string;
}>;

interface ErrorTags {
    isSendTeams: string;
}

// 暂时写死
const sendTeamsCodeLists = [400, 404, 500, 502, 503, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008];

const headersToObject = (headers: Response['headers']) => {
    const headersObj: HeadersInit = {};
    if (!headers) return headersObj;
    headers.forEach((value, key) => {
        headersObj[key] = value;
    });
    return headersObj;
};

export class NetworkError extends Error {
    extra: ErrorExtraType;
    tags: ErrorTags;

    constructor({ request, err, response }: { request: any; err: any; response: Response }) {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NetworkError);
        }
        const url = request?.url || response?.url;
        this.extra = {
            url,
            method: request?.method,
            request: {
                headers: request?.headers,
                body: request?.body,
            },
        };
        const i = url.indexOf('?');
        // eslint-disable-next-line eqeqeq
        const newUrl = i == -1 ? url : url.slice(0, i);
        if (response && err && err.code) {
            if (!sendTeamsCodeLists.includes(Number(err.code))) {
                this.tags = {
                    isSendTeams: 'false',
                };
            }
            this.extra.response = {
                headers: headersToObject(response?.headers),
                body: err,
            };
            this.extra.traceId = response?.headers.get('x-trace-id') || err?.traceId;
            this.extra.status = response?.status;
            this.extra.statusText = response?.statusText;
            this.name = `NetworkError-${err.code}(${newUrl})`;
            // 补全 message：API 码错误（1001/1003/503…）原本只设了 name、message 为空，
            // 会被 sentry.ts beforeSend 的「空 message（'No error message'）丢弃」规则误杀 → 整类漏报。
            // 给它一个有意义的 message（接口已透传 err.message，缺省用 API Error <code>）即可正常上报。
            this.message = err?.message || `API Error ${err.code}`;
        } else if (err && err.message) {
            this.name = `NetworkError-1(${newUrl})`;
            this.message = err?.message || '';
        }
    }
}
